import Menu from '../components-ui/spark/Menu';
import MenuItem from '../components-ui/spark/MenuItem';
import { Divider, ListItemIcon } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { ChevronDownIcon } from '@primer/octicons-react';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/useAppSelector';
import { usePermission } from '../hooks/usePermission';
import UnlockRequestBell from '../pages/xet-tuyen-thac-sy/nhap-diem-theo-lop/UnlockRequestBell';
import styles from './Header2.module.css';

type Props = { onToggleNavigation?: () => void; navigationOpen?: boolean; query?: string; onQueryChange?: (query: string) => void };

const Header2 = forwardRef<HTMLDivElement, Props>(({onToggleNavigation, navigationOpen, query = '', onQueryChange}, ref) => {
    const navigate = useNavigate();
    const user = useAppSelector(state => state.auth.user);
    const { hasMenuAccess } = usePermission();
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);
    const searchRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k' && searchRef.current?.getClientRects().length) {
                event.preventDefault(); searchRef.current.focus(); searchRef.current.select();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);
    const displayName = user?.full_name?.trim() || user?.username || 'Người dùng';
    const initials = displayName.split(/\s+/).slice(-2).map(part => part[0]).join('').toUpperCase();
    const roleCode = String(user?.MaNhomQuyen || '').trim().toUpperCase();
    const roleLabel = roleCode === 'QUANTRI' ? 'Quản trị' : roleCode === 'GIANGVIEN' ? 'Giảng viên' : 'Tài khoản ICTU';

    return (
        <div ref={ref} className={styles.header + ' navbar-custom'} role="banner">

            <div className={styles.tools}>
                {onToggleNavigation && <button type="button" className={styles.toggle}
                    onClick={onToggleNavigation} aria-label="Mở hoặc thu gọn menu"
                    aria-controls="app-navigation" aria-expanded={navigationOpen}>
                    <i className="bi bi-list" aria-hidden="true" />
                </button>}
                <div className={styles.context}>
                    <strong>Trường Đại học Công nghệ thông tin và truyền thông Thái Nguyên</strong>
                    <span>Phần mềm quản lý học bổ sung kiến thức</span>
                </div>
                {onQueryChange && <div className={styles.search} role="search">
                    <input ref={searchRef} className="navbar-search-input" value={query} onChange={event => onQueryChange(event.target.value)}
                        placeholder="Tìm chức năng... (Ctrl+K)" aria-label="Tìm chức năng"
                        onKeyDown={event => {
                            if (event.key === 'Escape') {onQueryChange('');searchRef.current?.blur();}
                            if (event.key === 'Enter') (document.querySelector('.sideMenu a[href]') as HTMLAnchorElement | null)?.click();
                        }} />
                    {query ? <button type="button" aria-label="Xóa tìm kiếm" onClick={() => onQueryChange('')}><i className="bi bi-x-lg"/></button>
                        : <i className="bi bi-search" aria-hidden="true"/>}
                </div>}
            </div>
            <div className={styles.actions}>
                {hasMenuAccess('BSKT_NHAPDIEM', '/nhap-diem-theo-lop') && <UnlockRequestBell />}
                <span className={styles.separator} />
                <button type="button" className={styles.account} onClick={event => setAnchor(event.currentTarget)}
                    aria-label={'Tài khoản ' + displayName} aria-haspopup="menu"
                    aria-controls={anchor ? 'account-menu' : undefined} aria-expanded={Boolean(anchor)}>
                    <span className={styles.avatar} aria-hidden="true">{initials}</span>
                    <span className={styles.accountText}><strong>{displayName}</strong><span>{roleLabel}</span></span>
                    <ChevronDownIcon size={14} />
                </button>
                <Menu id="account-menu" anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
                    anchorOrigin={{horizontal:'right',vertical:'bottom'}} transformOrigin={{horizontal:'right',vertical:'top'}}
                    slotProps={{paper:{sx:{minWidth:230,mt:1}}}}>
                    <MenuItem disabled sx={{opacity:'1 !important',display:'block',whiteSpace:'normal'}}>
                        <strong>{displayName}</strong><div style={{fontSize:12,color:'#718096'}}>{roleLabel}</div>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => {setAnchor(null);navigate('/signout-oidc');}}>
                        <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>Đăng xuất
                    </MenuItem>
                </Menu>
            </div>
        </div>
    );
});
Header2.displayName = 'Header2';
export default Header2;
